/**
 * Prevents the input of invalid characters in a range input.
 *
 * @param {Event} event The keyboard event triggered by user input.
 * @return {void}
 */
function preventInvalidCharacters( event ) {

	if ( ['e', '+', '-', '.', ','].includes( event.key ) ) {

		event.preventDefault();

	}

}
/**
 * Validates the input value of a given input element.
 *
 * @param {HTMLInputElement} inputElement - The input element to validate.
 *
 * @return {void}
 */
function validateInput( inputElement ) {

	const inputValue = inputElement.value;
	const cleanedValue = inputValue.replace( /[^0-9]/g, '' );
	inputElement.value = cleanedValue;
	if ( inputElement ) {

		const inputMax = inputElement.getAttribute( 'max' );
		if ( inputMax && parseInt( cleanedValue ) > parseInt( inputMax ) ) {

			inputElement.value = inputMax;

		}

	}

}

/**
 *
 */
function addInputsEvent() {

	const devicesNumber = document.getElementById( 'devicesNumber' );
	const employeesNumber = document.getElementById( 'employeesNumber' );

	if ( devicesNumber ) {

		devicesNumber.addEventListener( 'keydown', preventInvalidCharacters );
		devicesNumber.addEventListener( 'input', function validate (  ) {

			validateInput( devicesNumber );

		} );
		setupInputConnection( 'devicesRange', devicesNumber );

	}
	if ( employeesNumber ) {

		employeesNumber.addEventListener( 'keydown', preventInvalidCharacters );
		employeesNumber.addEventListener( 'input', function validate (  ) {

			validateInput( employeesNumber );

		} );
		setupInputConnection( 'employeesRange', employeesNumber );

	}

}

/**
 * Setup the input connection between a range input and a number input.
 *
 * @param {string} rangeInputId - The ID of the range input element.
 * @param {HTMLElement} numberInput - The number input element.
 *
 * @return {void}
 */
function setupInputConnection( rangeInputId, numberInput ) {

	const rangeInput = document.getElementById( rangeInputId );

	if ( rangeInput ) {

		rangeInput.addEventListener( 'input', function dispatch () {

			numberInput.value = this.value;
			numberInput.dispatchEvent( new Event( 'change' ) );

		} );

	}

	if ( numberInput ) {

		numberInput.addEventListener( 'input', function dispatch () {

			rangeInput.value = this.value;
			rangeInput.dispatchEvent( new Event( 'change' ) );

		} );

	}

}


if ( document.readyState === 'loading' ) {

	document.addEventListener( 'DOMContentLoaded', addInputsEvent );

} else {

	addInputsEvent();

}
